<template lang="pug">
	modal(:max-width="550", v-if="tipoMovimiento")
		.card.text-left
			.card-header.bg-warning
				span.fa.fa-edit.mr-2
				| Registrar jornada
				button.close(@click="cerrar") &times;
			.card-body.bg-danger.text-white.m-0.p-0
				div.text-center.tipoMovimiento {{tipoMovimiento}}
			.card-body.bg-light(v-if="ultimoRegistro")
				span.fa.fa-info-circle.mr-2
				| La entrada se fichó el {{ultimoRegistro.FechaInicioJornada}}
			.card-body
				.row
					.col-xs-12.col-sm-12.col-md-12.col-lg-12.mb-2
						.input-group.input-group-lg
							.input-group-prepend
								.input-group-text
									span.fa.fa-calendar.fa-w
							input.form-control(:disabled="true", :value="fecha")
					.col-xs-12.col-sm-12.col-md-12.col-lg-12.mb-2
						.input-group.input-group-lg
							.input-group-prepend
								.input-group-text
									span.fa.fa-clock-o.fa-w
							input.form-control(v-if="hora === null" disabled="true" :value="ahora")
							input.form-control(v-if="hora !== null" type="time", size="5", v-mask="'##:##'", placeholder="HH:MM", v-model="hora")
							.input-group-append
								button.btn.btn-primary(v-if="hora !== null" @click="setAhora(true)", title="Establece la fecha y la hora actual")
									span.fa.fa-clock-o
								button.btn.btn-danger(v-else @click="setAhora(false)")
									span.fa.fa-edit
			.card-body
				.form-group
					label Comentarios (opcional)
					textarea.form-control(v-model="comentarios")
				.text-center
					button.btn.btn-lg.btn-primary(@click="guardar()")
						span.fa.fa-save.mr-2
						| Fichar
			div(id="mapaFichar")



</template>

<script>
import { mapGetters } from 'vuex'
export default {
	data () {
		return {
			fecha: this.$moment().format('YYYY-MM-DD'),
			hora: null,
			ip: null,
			externo: false,
			comentarios: null,
			ultimoRegistro: false,
			tipoJornada: 'Normal',
			UsuarioID: null,
			tiposJornadas: [
				'Normal',
				'Extra',
				'Libre',
				'Nocturna'
			],
			latitud: null,
			longitud: null,
			map: null,
			marcador: null,
			tipoRegistro: null,
			ahora: this.$moment().format('HH:mm'),
			intervalo: null
		}
	},
	created () {
		this.getIP(() => {
			if (!navigator.geolocation) {
				this.$error('Error', 'Debes fichar en un navegador que soporte geolocalización')
				this.cerrar()
			}

			// Detectamos pc o movil
			var check = false;
			// eslint-disable-next-line
			(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
			this.tipoRegistro = check ? 'Móvil' : 'PC'
		})

		this.intervalo = window.setInterval(() => {
			this.ahora = this.$moment().format('HH:mm:ss')
		}, 200)
	},
	beforeDestroy () {
		window.clearInterval(this.intervalo)
	},
	mounted () {
		navigator.geolocation.getCurrentPosition(this.init.bind(this), (err) => {
			console.error('Error geolocalizando')
			console.error(err)
			// this.$error('Error', 'Es necesaria la geolocalización para efectuar el fichaje')
			// this.cerrar()
			this.$store.commit('toast/danger', {
				titulo: 'Geolocalización no disponible',
				mensaje: 'No es posible geolocalizar este dispositivo.'
			})
			this.externo = true
			this.init()
		})
	},
	watch: {
		tipoMovimiento (newVal) {
			if (newVal && !this.map) {
				window.setTimeout(() => {
					this.initMap()
				}, 500)
			}
		}
	},
	computed: {
		tipoMovimiento () {
			if (this.ultimoRegistro === undefined || this.ultimoRegistro === false) {
				return false
			}

			if (this.ultimoRegistro === null) {
				return 'Entrada'
			}

			if (!this.ultimoRegistro.FechaFinJornada) {
				return 'Salida'
			}

			return 'Entrada'
		},
		tiempoJornada () {
			const exp = /^[0-9]{2}:[0-9]{2}$/
			if (!exp.test(this.horaFin)) {
				return null
			}
			let fechaEntrada
			if (this.tipoRegistro === 'Salida') {
				// Calculamos
				fechaEntrada = new Date(this.ultimoRegistro.FechaInicioJornada * 1000)
			} else if (this.tipoRegistro !== 'Entrada') {
				fechaEntrada = new Date(this.fechaInicio.getTime())
			} else {
				return null
			}

			const fechaSalida = new Date(this.fechaFin.getTime())
			const hora = this.horaFin.split(':')
			fechaSalida.setHours(parseInt(hora[0]))
			fechaSalida.setMinutes(parseInt(hora[1]))

			let dif = fechaSalida.getTime() - fechaEntrada.getTime()

			if (dif < 0) {
				return 0
			}

			dif = Math.floor(dif / 1000)
			let horas = Math.floor(dif / 3600)
			dif = dif % 3600
			let minutos = Math.floor(dif / 60)

			horas = (horas < 10) ? '0' + horas : horas
			minutos = (minutos < 10) ? '0' + minutos : minutos

			return horas + ':' + minutos
		},
		...mapGetters({
			usuario: 'session/usuario'
		})
	},
	methods: {
		init (pos) {
			if (this.externo && pos) {
				this.latitud = pos.coords.latitude
				this.longitud = pos.coords.longitude
			} else {
				this.latitud = 39.985061
				this.longitud = -0.020440
			}

			this.getUltimo()
		},
		initMap () {
			if (!this.latitud || !this.longitud) {
				this.$store.commit('toast/danger', {
					titulo: 'Geolocalización no disponible',
					mensaje: 'No es posible geolocalizar este dispositivo.'
				})
				return
			}
			// eslint-disable-next-line
			this.map = new google.maps.Map(document.getElementById('mapaFichar'), {
				center: {lat: this.latitud, lng: this.longitud},
				zoom: 16
			})

			// eslint-disable-next-line
			this.marcador = new google.maps.Marker({
				// eslint-disable-next-line
				position: new google.maps.LatLng(this.latitud, this.longitud),
				title: 'Tu posición',
				map: this.map
			})
		},
		getIP (callback) {
			this.$http.get('core/php/api/sesion/get.php')
				.then(res => {
					this.ip = res.data.ip
					this.externo = res.data.externo
					callback()
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: 'Error obteniendo la IP'
					})
					this.cerrar()
				})
		},
		getUltimo () {
			this.$http.get('gestion-jornada/php/api/getUltimo.php')
				.then(res => {
					if (!res.data) {
						this.ultimoRegistro = null
					} else {
						this.ultimoRegistro = res.data
					}
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		setAhora (ahora) {
			if (ahora) {
				this.hora = null
			} else {
				this.hora = this.$moment().format('HH:mm')
			}
		},
		guardar () {
			const datos = {}
			const exp = /^(Entrada|Salida)$/
			if (!exp.test(this.tipoMovimiento)) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Tipo de registro no válido'
				})
				return
			}

			datos.TipoMovimiento = this.tipoMovimiento

			datos.Hora = this.hora

			datos.UsuarioID = this.usuario.ID
			datos.Comentarios = this.comentarios

			datos.Latitud = this.latitud
			datos.Longitud = this.longitud
			datos.TipoRegistro = this.tipoRegistro

			const url = 'gestion-jornada/php/api/fichar.php'
			this.$http.post(url, datos)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Registro guardado'
					})
					this.cerrar()
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
#mapaFichar {
	height: 350px;
}

.tipoMovimiento {
	text-transform: uppercase;
	font-size: 4em;
	font-weight: bold;
	padding: 2px;
	font-kerning: 2em;
	margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/modulos/gestion-jornada/vue/components/editor/fichar.vue